import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import TextField from '../../../atoms/forms/TextField';
import { IconSearch } from '../../../atoms/images/Icon';

import tr from '../../../../locales';

import { InstantSearchPortal } from '../../global/InstantSearch/portal';

// tslint:disable-next-line:no-empty-interface
interface IOwnProps {
  size?: TextFieldSize;
}

interface IOwnState {
  searchInput: string;
}

const classes = new BEM('search-box');

export class SearchBox extends React.Component<IOwnProps, IOwnState> {

  constructor(props: IOwnProps) {
    super(props);

    this.state = {
      searchInput: '',
    };
  }

  onSearchInput: React.ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    this.setState({ searchInput: target.value });
  }

  onCloseInstantSearch = () => {
    this.setState({ searchInput: '' });
  }

  render() {
    // const hasFilters = false;
    const { size } = this.props;
    return (
      <div {...classes('')}>
        <TextField
          name="search-box"
          placeholder={size === 'small' ? 'Search' : tr.search.placeholder}
          size={size}
          icon={<IconSearch />}
          onChange={this.onSearchInput}
          value={this.state.searchInput}
          isControlled
          {...classes('search', { [size!]: !!size})}
        />
        {this.state.searchInput !== '' && (
          <InstantSearchPortal
            initialInput={this.state.searchInput}
            onSearchInput={this.onSearchInput}
            onClose={this.onCloseInstantSearch}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/SearchBox/index.tsx